import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/dashboard_elements/total_progress_each_block');
  return response.data;
}

export default {
  index,
};
